import { Alert } from '@/components/ui/Alert';
import type { FormErrors } from '@/lib/form-errors';

/**
 * Aviso de error de un formulario: el mensaje que devolvió el backend (`getErrorMessage`) y,
 * debajo, los mensajes de validación que no se pudieron asociar a un campo concreto.
 *
 * El segundo caso es el de los errores que no son de ningún campo: un `refine` sobre el objeto
 * completo del schema (p. ej. `PATCH /settings` con `{}`) o un fallo de `params`/`query`. Todo lo
 * que sí pertenece a un campo se pinta debajo de su `Input`, con `Field`
 * (ver `src/lib/form-errors.ts`).
 */

export interface FormErrorAlertProps {
  /** Mensaje del backend para el usuario. `null` = no hay nada que mostrar. */
  message: string | null;
  /** Errores del formulario (los `formMessages` son los que salen en la lista). */
  errors: FormErrors;
  className?: string;
}

export function FormErrorAlert({ message, errors, className }: FormErrorAlertProps) {
  if (!message) return null;

  return (
    <Alert className={className}>
      <p className="font-medium">{message}</p>

      {errors.formMessages.length > 0 ? (
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          {errors.formMessages.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
    </Alert>
  );
}
